import React from 'react';

const LengthIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60.088" height="32.847" viewBox="0 0 60.088 32.847"><g opacity=".5" stroke="#fff" strokeWidth="1.4" fill="none"><path d="M31.74 24.7l-31.039-.553v-14.813l12.171-8.576 18.23 4.557 24.414 3.714v12.318zM31.787 5.69l-.443 19.066-10.187-.207.139-10.273h-9.543v9.986"/></g><path d="M32.84 30.024l25.818-3.923" stroke="#d59300" strokeWidth="2" fill="none"/><path d="M33.882 27.301l.87 4.925-3.55-1.498zM56.893 23.648l.699 4.954 2.911-2.525z" fill="#d59300"/></svg>

  )
}
export default LengthIcon;